import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalCampaignOrderService } from './local-campaign-order.service';

@Injectable({
  providedIn: 'root'
})
export class OrderAlertService implements OnDestroy {

  private knownIds: Set<number> = new Set();
  private pendingAlertCount = 0;
  private intervalId: any = null;

  private _showAlert$ = new BehaviorSubject<boolean>(false);
  private _alertCount$ = new BehaviorSubject<number>(0);

  showAlert$ = this._showAlert$.asObservable();
  alertCount$ = this._alertCount$.asObservable();

  constructor(private localCampaignOrderService: LocalCampaignOrderService) {}

  startPolling(): void {
    this.fetchAndEvaluate();
    this.intervalId = setInterval(() => this.fetchAndEvaluate(), 120000);
  }

  dismissAlert(): void {
    this.pendingAlertCount = 0;
    this._showAlert$.next(false);
    this._alertCount$.next(0);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private fetchAndEvaluate(): void {
    this.localCampaignOrderService.getPendingOrderValidationIds().subscribe(ids => {
      const newIds = ids.filter(id => !this.knownIds.has(id));
      if (newIds.length > 0) {
        this.pendingAlertCount += newIds.length;
        this._alertCount$.next(this.pendingAlertCount);
        this._showAlert$.next(true);
      }
      this.knownIds = new Set(ids);
    });
  }
}
